/**
 * NarrowScreenBanner — small dismissible "Vive mejor en desktop" banner.
 * Appears below 1200px, dismissed state persists in localStorage.
 * Mobile-optimized v2 stays in `_prototype/` as future reference.
 */

import { useEffect, useState } from 'react';

const STORAGE_KEY = 'nyx-narrow-banner-dismissed';
const NARROW_BREAKPOINT = 1200;

export function NarrowScreenBanner(): JSX.Element | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = window.localStorage.getItem(STORAGE_KEY) === '1';
    if (dismissed) return;

    const mql = window.matchMedia(`(max-width: ${NARROW_BREAKPOINT - 1}px)`);
    const onChange = (e: MediaQueryListEvent | MediaQueryList) => setVisible(e.matches);
    onChange(mql);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    window.localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  return (
    <div className="nl-narrow-banner" role="status" aria-live="polite">
      <div className="nl-narrow-banner-inner">
        <span className="nl-narrow-banner-mark" aria-hidden="true">
          ★
        </span>
        <span className="nl-narrow-banner-text">
          <strong>Vive mejor en desktop.</strong>
          <span className="nl-narrow-banner-sub">
            Esta lectura está pensada para una pantalla grande. Volvé a abrirla con más espacio.
          </span>
        </span>
        <button
          type="button"
          className="nl-narrow-banner-close"
          aria-label="Ocultar el aviso"
          onClick={dismiss}
        >
          ✕
        </button>
      </div>
    </div>
  );
}
